import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteComponent } from "../../services/component";
import { toast } from "react-toastify";

const useDeleteComponent = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteComponent,

        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["categories"] });
                toast.success("Component deleted successfully");
            }
        },
        onError: (error: any) => {
            toast.error(error.response?.data?.message);
        }
    });
};

export default useDeleteComponent;